const ConfirmDialog = ({ message, onConfirm, onCancel, confirmLabel = 'Confirm', danger = true }) => (
  <div style={S.overlay}>
    <div style={S.box}>
      <div style={S.icon}>{danger ? '⚠' : 'ℹ'}</div>
      <div style={S.message}>{message}</div>
      <div style={S.btnRow}>
        <button style={S.cancel} onClick={onCancel}>Cancel</button>
        <button style={{ ...S.confirm, ...(danger ? S.confirmDanger : S.confirmPrimary) }} onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </div>
  </div>
);

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(6,13,58,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
    backdropFilter: 'blur(2px)',
  },
  box: {
    background: '#fff', borderRadius: 18, padding: '32px 28px', width: 360,
    boxShadow: '0 20px 60px rgba(6,13,58,0.25)', textAlign: 'center',
  },
  icon: { fontSize: 36, marginBottom: 12 },
  message: { fontSize: 14, fontWeight: 500, color: '#0B1554', marginBottom: 24, lineHeight: 1.6, whiteSpace: 'pre-line' },
  btnRow: { display: 'flex', gap: 10 },
  cancel: {
    flex: 1, padding: '11px', border: '1.5px solid #e5e7eb', borderRadius: 10,
    background: '#fff', color: '#374151', fontSize: 14, fontWeight: 600, cursor: 'pointer',
  },
  confirm: {
    flex: 1, padding: '11px', border: 'none', borderRadius: 10,
    color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer',
  },
  confirmDanger: {
    background: 'linear-gradient(135deg,#dc2626,#ef4444)',
    boxShadow: '0 4px 14px rgba(220,38,38,0.35)',
  },
  confirmPrimary: {
    background: 'linear-gradient(135deg,#0d1a6e,#4f6ef7)',
    boxShadow: '0 4px 14px rgba(79,110,247,0.35)',
  },
};

export default ConfirmDialog;
